import OperatorPaymentList from "./list/list";

export default OperatorPaymentList;
